import type { Movie } from "@/types";
import { Link } from "react-router-dom";

interface MovieCardProps {
  movie: Movie;
  showSummary?: boolean;
}

export default function MovieCard({ movie, showSummary = true }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors duration-300 hover:border-primary-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title}电影封面`}
          title={`${movie.title}剧情介绍与演员资料`}
          className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-foreground-950/80 to-transparent" />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-2.5 py-1 text-[11px] font-medium text-foreground-800">
          {movie.year}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-semibold text-background-50">
          <i className="ri-star-fill text-[10px]" />
          {movie.rating.toFixed(1)}
        </span>
        <p className="absolute bottom-3 left-3 right-3 truncate text-xs text-background-100/90">
          {movie.genres.join(" · ")}
        </p>
      </div>
      <div className="flex flex-1 flex-col gap-1.5 p-3.5 md:p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-accent-600">
          {movie.title}
        </h3>
        <p className="text-[11px] uppercase tracking-[0.12em] text-foreground-400">
          {movie.englishTitle}
        </p>
        {showSummary && (
          <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">
            {movie.summary}
          </p>
        )}
      </div>
    </Link>
  );
}